var hasProp = window.hasProp;
var extend = window.extend;
var bind = window.bind;
var bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.Notifications.ListView = function (superClass) {
  extend(ListView, superClass);
  function ListView() {
    this.maybeFetchNotifications = bind(this.maybeFetchNotifications, this);
    return ListView.__super__.constructor.apply(this, arguments);
  }
  ListView.prototype.className = 'js-notification-list notification-list';
  ListView.prototype.initialize = function (options) {
    this.mostRecentNotifications = new Aedu.Notifications.MostRecentNotifications();
    this.notifications = this.mostRecentNotifications.get('notifications');
    this.listenTo(this.notifications, 'add', this.addNotification);
    this.enableScrollScope();
    this.$el.scroll(this.maybeFetchNotifications);
    return this.fetchNotifications();
  };
  ListView.prototype.enableScrollScope = function () {
    return Aedu.Behaviors.ScrollScope.enable(this.$el);
  };
  ListView.prototype.fetchNotifications = function () {
    var errorMessage;
    if (!Aedu.serviceAvailability.serviceEnabled("notifications_db")) {
      errorMessage = $(JST['notifications/templates/notifications_unavailable']());
      this.$el.append(errorMessage);
      return;
    }
    this.appendSpinner();
    return this.mostRecentNotifications.fetch().success(function (_this) {
      return function () {
        _this.resetScroll();
        _this.infiniteScrollActive = !_this.mostRecentNotifications.get('depleted');
        _this.removeSpinner();
        _this.markRead();
        return _this.maybeFetchNotifications();
      };
    }(this));
  };
  ListView.prototype.appendSpinner = function () {
    var $spinner;
    $spinner = $(JST['notifications/templates/notification_spinner']());
    return this.$el.append($spinner);
  };
  ListView.prototype.resetScroll = function () {
    if (!this.isScrollReset) {
      this.el.scrollTop = 0;
      return this.isScrollReset = true;
    }
  };
  ListView.prototype.removeSpinner = function () {
    return this.$('.js-notifications-spinner').remove();
  };
  ListView.prototype.markRead = function () {
    return $.post($r.mark_read_api_v0_notification_messages_path({
      subdomain_param: "api"
    }));
  };
  ListView.prototype.addNotification = function (newNotification) {
    return this.$el.append(newNotification.view().el);
  };
  ListView.prototype.maybeFetchNotifications = function () {
    if (this.infiniteScrollActive && this.isNearBottom()) {
      this.infiniteScrollActive = false;
      return this.fetchNotifications();
    }
  };
  ListView.prototype.isNearBottom = function () {
    var scrollOffset;
    scrollOffset = 20;
    return this.$el.scrollTop() + this.$el.innerHeight() >= this.el.scrollHeight - scrollOffset;
  };
  return ListView;
}(Backbone.View);
window.bind = bind;
window.extend = extend;
window.hasProp = hasProp;